import PageContact from '../components/page-contact'
import Seo from '../components/seo'

const Contact = () => (
  <>
    <Seo title="Contact" />
    <PageContact />
  </>
)

export default Contact
